import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {CustomTabPanel} from "../../../utils/utilityComponents";
import TextPanel from "./TextPanel";
import ScripturePrayersPanel from "./ScripturePrayers";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function TextTabs({setToggleSubMenu}) {
    const [value, setValue] = useState(0);
    const {activeObject} = useSelector((state) => state.canvas);

    useEffect(() => {
        if(activeObject?.type === 'image'){
            setValue(0)
        }
    },[activeObject])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs className='images-panel-tabs' sx={{ justifyContent: 'space-between' }} value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Text" {...a11yProps(0)} />
                    <Tab label="Scriptures" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <TextPanel setToggleSubMenu={setToggleSubMenu}/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <ScripturePrayersPanel setToggleSubMenu={setToggleSubMenu}/>
            </CustomTabPanel>
        </Box>
    );
}
